import React, { useEffect, useState } from 'react';
import Sidebar from './Sidebar';
import API from '../../utils/api';

export default function MainLayout({ children }) {
  const [alertCount, setAlertCount] = useState(0);

  useEffect(() => {
    const fetchAlerts = async () => {
      try {
        const { data } = await API.get('/alerts');
        setAlertCount(data.length);
      } catch {}
    };
    fetchAlerts();
    const interval = setInterval(fetchAlerts, 60000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="animated-bg min-h-screen">
      <Sidebar alertCount={alertCount} />
      <div className="lg:mr-64 pt-16 lg:pt-0 min-h-screen">
        <main className="p-4 lg:p-6 max-w-7xl mx-auto">
          {children}
        </main>
      </div>
    </div>
  );
}
